import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
    id: "beneficios",
    class: "benefits"
};
var _hoisted_2 = { class: "container" };
var _hoisted_3 = { class: "row justify-content-around pt-4" };
var _hoisted_4 = { class: "step-data col-6 col-md-3 col-xl-2" };
var _hoisted_5 = { class: "d-flex justify-content-center" };
var _hoisted_6 = { class: "d-flex flex-column align-items-center" };
var _hoisted_7 = { class: "icon-wrapper" };
var _hoisted_8 = { class: "step-data col-6 col-md-3 col-xl-2" };
var _hoisted_9 = { class: "d-flex justify-content-center" };
var _hoisted_10 = { class: "d-flex flex-column align-items-center" };
var _hoisted_11 = { class: "icon-wrapper" };
var _hoisted_12 = { class: "step-data col-6 col-md-3 col-xl-2" };
var _hoisted_13 = { class: "d-flex justify-content-center" };
var _hoisted_14 = { class: "d-flex flex-column align-items-center" };
var _hoisted_15 = { class: "icon-wrapper" };
var _hoisted_16 = { class: "step-data col-6 col-md-3 col-xl-2" };
var _hoisted_17 = { class: "d-flex justify-content-center" };
var _hoisted_18 = { class: "d-flex flex-column align-items-center" };
var _hoisted_19 = { class: "icon-wrapper" };
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
export default /*@__PURE__*/ _defineComponent({
    __name: 'HomeBenefits',
    setup: function (__props) {
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "text-center" }, "Beneficios destacados", -1)),
                    _cache[13] || (_cache[13] = _createElementVNode("h5", { class: "text-center" }, "¿Por que elegir Subslot?", -1)),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createVNode(_unref(FontAwesomeIcon), {
                                            class: "first",
                                            icon: ['fas', 'brain']
                                        })
                                    ]),
                                    _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "text-center mt-3" }, "Ahorro inteligente", -1)),
                                    _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-center" }, "Comparte el costo de tus suscripciones y paga solo una fracción del precio original.", -1)),
                                    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-center" }, "Más servicios por menos.", -1))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createVNode(_unref(FontAwesomeIcon), {
                                            class: "second",
                                            icon: ['fas', 'user-lock']
                                        })
                                    ]),
                                    _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "text-center mt-3" }, "Seguridad y privacidad", -1)),
                                    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-center" }, "Protegemos tus datos y accesos con procesos seguros.", -1)),
                                    _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-center" }, "Tú decides qué compartes.", -1))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("div", _hoisted_15, [
                                        _createVNode(_unref(FontAwesomeIcon), {
                                            class: "third",
                                            icon: ['fas', 'calendar']
                                        })
                                    ]),
                                    _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-center mt-3" }, "Sin contratos largos", -1)),
                                    _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-center" }, "Paga mes a mes, sin ataduras ni cargos ocultos.", -1)),
                                    _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-center" }, "Cancela cuando quieras, sin complicaciones.", -1))
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, [
                                    _createElementVNode("div", _hoisted_19, [
                                        _createVNode(_unref(FontAwesomeIcon), {
                                            class: "fourth",
                                            icon: ['fas', 'bolt']
                                        })
                                    ]),
                                    _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-center mt-3" }, "Acceso inmediato", -1)),
                                    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-center" }, "Suscríbete y accede en minutos.", -1)),
                                    _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-center" }, "Recibe los datos de forma automática tras el pago.", -1))
                                ])
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
